import { render, staticRenderFns } from "./searchSthx.vue?vue&type=template&id=1f34161b&"
import script from "./searchSthx.vue?vue&type=script&lang=js&"
export * from "./searchSthx.vue?vue&type=script&lang=js&"
import style0 from "./searchSthx.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports